import { useEffect } from "react";
import { Input, Form } from "antd";
import { getLangList } from '@/lib/i18n';
import { modalFromLayout } from "@/lib/antdElementFunction";
import { DepartmentType } from './types';

interface Props {
  form: any;
  info: DepartmentType;
  handleType: string;
}

function ModalDepartment(props: Props) {
  const { form, info, handleType } = props;
  const organizationT: any = getLangList("organization");

  useEffect(() => {
    const { departmentName } = info ?? {};

    handleType === 'update' && form.setFieldsValue({ departmentName });
  }, [form, info, handleType]);

  return (
    <Form
      className="admin-form"
      style={{ marginTop: 20 }}
      {...modalFromLayout}
      form={form}
    >
      <Form.Item
        label={organizationT.DEPARTMENT}
        name="departmentName"
        rules={[{ required: true }]}
      >
        <Input />
      </Form.Item>
    </Form >
  );
}

export default ModalDepartment;